import api, { Base, Tags } from 'ev-api/api';

import {
  CdxModule,
  CdxModulesListResponse,
  CdxProxyEnvelope,
  GetModuleParams,
  ListModulesParams,
} from './module-types';

const cdxModulesApi = api.injectEndpoints({
  endpoints: builder => ({
    listModules: builder.query<CdxModule[], ListModulesParams | void>({
      query: params => ({
        url: `${Base.V4}/cdx_proxy/config/modules`,
        params: {
          'filter[auto_render]': true,
          ...(params && params.page ? { page: params.page } : {}),
        },
      }),
      transformResponse: (response: CdxModulesListResponse) =>
        response.data.modules,
      providesTags: [Tags.CdxModules],
    }),
    getModule: builder.query<CdxModule, GetModuleParams>({
      query: ({ handle }) => ({
        url: `${Base.V4}/cdx_proxy/config/modules/${handle}`,
      }),
      transformResponse: (response: CdxProxyEnvelope<CdxModule>) =>
        response.data,
      providesTags: [Tags.CdxModules],
    }),
  }),
});

export const { useListModulesQuery, useGetModuleQuery } = cdxModulesApi;
